<template>
    <div>
        <el-form :rules="rules" ref="lineForm" :model="lineList" label-width="110px" size="mini">
            <el-form-item prop="khid" class="lable-width" label="仓库名称" :rules="{required: true, message: '请选择仓库', trigger: 'blur'}">
                <el-select
                           class="input-width"
                           v-model="lineList.khid"
                           filterable
                           @change="ckchange"
                           :disabled="ckHide"
                           placeholder="请选择">
                    <el-option
                            v-for="item in ckdata"
                            :key="item.warehouseId"
                            :label="item.warehouseName"
                            :value="item.warehouseId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="pid" class="lable-width" label="库区名称" :rules="{required: true, message: '请选择库区', trigger: 'change'}">
                <el-select  ref="kq1"
                            clearable
                            class="input-width"
                            v-model="lineList.pid"
                            @change=" kqidchange"
                            filterable
                            :disabled="kqHide"
                            placeholder="请选择">
                    <el-option
                            ref="kq2"
                            v-for="item in kqdata"
                            :key="item.storekqId"
                            :label="item.storekqName"
                            :value="item.storekqId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="code" class="lable-width" label="货位号"　:rules="{required: true, message: '请输入货位号', trigger: 'blur'}">
                <el-input class="input-width" placeholder="请输货位号" clearable v-model="lineList.code" :disabled="isHide"></el-input>
            </el-form-item>
            <el-form-item prop="area" class="lable-width" label="区域名"　:rules="{required: true, message: '请输入区域名', trigger: 'blur'}">
                <el-input class="input-width" placeholder="请输入区域名" clearable v-model="lineList.area" :disabled="isHide"></el-input>
            </el-form-item>
            <el-form-item prop="mj" class="lable-width" label="面积(m²)" >
                <el-input class="input-width" placeholder="请输入面积"  clearable v-model="lineList.mj" :disabled="isHide"></el-input>
            </el-form-item>
            <el-form-item prop="rl" class="lable-width" label="容量(t)">
                <el-input class="input-width" placeholder="请输入容量" disabled clearable v-model="lineList.rl"></el-input>
            </el-form-item>
            <el-form-item prop="note" class="lable-width" :label="$t('form_notes')">
                <el-input class="input-width" placeholder="请输入备注" clearable v-model="lineList.note" :disabled="isHide"></el-input>
            </el-form-item>
            <el-form-item prop="danger" class="lable-width" label="是否危险品" :rules="{required: true, message: '请选择是否危险品', trigger: 'change'}">
                <div style="margin-left:20px; text-align: left;" >
                    <el-radio v-model="lineList.isdangerous" :label="1" >是</el-radio>
                    <el-radio v-model="lineList.isdangerous" :label="0">否</el-radio>
                </div>
            </el-form-item>
            <el-form-item prop="state" class="lable-width" label="状态">
                <div style="margin-left:20px; text-align: left;">
                    <el-radio v-model="lineList.state" :label="1">启用</el-radio>
                    <el-radio v-model="lineList.state" :label="0">不启用</el-radio>
                </div>
            </el-form-item>
            <el-form-item prop="lruName" class="lable-width" label="录入人姓名">
                <div style="margin-left: 0px;position: relative">
                    <el-input  class="input-width" label="123" disabled  clearable v-model="lineList.lruName"></el-input>
                </div>
            </el-form-item>
            <el-form-item class="lable-width" style="margin-left: 0">
                <el-button style="margin-left: 0" type="primary" @click="onSubmit" :disabled="isDisable">{{$t('button_save')}}</el-button>
                <el-button type="primary" @click="close">取消</el-button>
            </el-form-item>
        </el-form>

    </div>
</template>

<script>
    import * as API from "../api";
    import {mapActions} from "vuex";
    export default {
        name: 'reviseTemplate',
        props:{
            title:{
              type:String
            },
            lineList1:{
              type:Object
            },

            listid:{
              type:Number
            }
        },
        data(){
            return{
                kqdata:'',
                ckdata:'',
                isDisable:false,
                isHide:false,
                ckHide:true,
                lineList:this.lineList1,
                kqHide:true,
                value:'',
                timeStamp:'',
                isHide:'',
                rules: {
                    mj: [
                        {required: true, message: '请输入面积', trigger: 'blur'},
                        {pattern: /^[0-9]+\.{0,1}[0-9]{0,15}$/, message: "请输入数字", trigger: "blur"},
                        {pattern: /^\d+(\.\d{1,5})?$/, message: "请保留五位小数", trigger: "blur"}
                    ]
                }

            }
        },
        watch:{
        },
        mounted(){
            this.selectWarehouse()
            this.isHide=false
            if(this.title=='编辑货位'){
                this.isHide=true
                this.getDetails()
            }
        },
        methods:{
            ckchange(val){
                this.lineList.khid=val
                this.selectStorekq()

            },
            kqidchange(val){
                this.lineList.pid=val
            },

            ...mapActions(["getCurrentMenuId"]),

            close(){
                this.$emit('close')
            },

            onSubmit(){
                this.save()
            },
            //仓库下拉
            async selectWarehouse(val) {

                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id) {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }

                let params={
                }
                let res = await API.selectWarehouse(params);
                if (res.code == 1) {
                    this.ckdata = res.data

                    let arr =  res.data;
                    this.lineList.khid=arr[0].warehouseId
                    this.selectStorekq()
                    this.ckHide=false
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //库区下拉
            async selectStorekq(val) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id) {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params={
                    khid: this.lineList.khid,
                }
                let res = await API.selectStorekq(params);
                if (res.code == 1) {

                    this.kqdata = res.data
                    this.kqHide=false
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            // 货位详情
            async getDetails() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    id:this.lineList.id,
                }
                let res = await API.getDetails(params);
                if (res.code == 1) {

                    this.lineList=res.data
                    // this.tableData.forEach(item=>{
                    //     item.createTime=item.createTime.substring(0,19)
                    //
                    // })
                    this.isHide=false
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //货位保存
            async save(val) {
                if(!this.lineList.khid){
                    this.$message({
                        message: '请选择仓库名称',
                        type: 'error'
                    });
                    return
                }
                if(!this.lineList.pid){
                    this.$message({
                        message: '请选择库区名称',
                        type: 'error'
                    });
                    return
                }
                if(!this.lineList.code){
                    this.$message({
                        message: '请输入货位号',
                        type: 'error'
                    });
                    return
                }
                if(!this.lineList.area){
                    this.$message({
                        message: '请输入区域名',
                        type: 'error'
                    });
                    return
                }
                if(this.lineList.mj===''){
                    this.$message({
                        message: '请输入面积',
                        type: 'error'
                    });
                    return
                }
                if(this.lineList.mj<0){
                    this.$message({
                        message: '请输入大于0的面积',
                        type: 'error'
                    });
                    return
                }
                if(isNaN(this.lineList.mj)){
                    this.$message({
                        message: '请输入数字',
                        type: 'error'
                    });
                    return
                }
                if(this.lineList.isdangerous==undefined){
                    this.$message({
                        message: '请选择是否危险品',
                        type: 'error'
                    });
                    return
                }
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    id:this.lineList.id,
                    code:this.lineList.code,
                    area:this.lineList.area,
                    note:this.lineList.note,
                    mj:this.lineList.mj,
                    rl:this.lineList.rl,
                    state:this.lineList.state,
                    khid:this.lineList.khid,
                    pid:this.lineList.pid,
                    isdangerous:this.lineList.isdangerous
                }
                this.isDisable = true
                let res = await API.save(params);
                if (res.code == 1) {
                    this.isDisable = false
                    this.$emit('clist')
                    this.$emit('getList')
                    this.$emit("close")
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.isDisable = false
                    this.$message.error(res.message);
                }
            },
        }
    }
</script>
<style lang="scss" scoped>
    /deep/{
        .lable-width .el-form-item__content{
            margin-left: 0 !important;
        }
        .el-textarea__inner{
            height: 100px !important;
            color: #000000 !important;
            /*font-weight: 600 !important;*/
            font-size: inherit !important;
        }
        .el-form-item__error{
            left: 50% !important;
        }
        .el-radio {
            margin-left: 30px;
        }
    }
    .lable-width{
        text-align: center;
    }
    .slable-width{

    }
    .dialog-footer{
        display: flex;
        justify-content: center;
        align-items: center;
        /*text-align: center;*/
        margin-top: 12px;
    }
    .input-width{
        /*text-align: center;*/
        width: 18.571rem;
    }
    .sinput-width{
        width: 150px;
        margin-left: 28px;
    }
    /deep/.json .el-textarea__inner{
        height: 180px !important;
    }
    /deep/.describe .el-textarea__inner{
        height: 80px !important;

    }
</style>